/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListAiAssistantToolsParams,
  PaginatedAiAssistantTools,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of AI Assistant Tools
 */
export const listAiAssistantTools = (
    params?: MaybeRefOrGetter<ListAiAssistantToolsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiAssistantTools>(
      {url: `/ai/assistant_tools`, method: 'GET',
        params, signal
    },
      );
    }




export const getListAiAssistantToolsQueryKey = (params?: MaybeRefOrGetter<ListAiAssistantToolsParams>,) => {
    return [
    'ai','assistant_tools', ...(params ? [params] : [])
    ] as const;
    }


export const getListAiAssistantToolsQueryOptions = <TData = Awaited<ReturnType<typeof listAiAssistantTools>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListAiAssistantToolsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAssistantTools>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiAssistantToolsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiAssistantTools>>> = ({ signal }) => listAiAssistantTools(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiAssistantTools>>, TError, TData>
}

export type ListAiAssistantToolsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiAssistantTools>>>
export type ListAiAssistantToolsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List of AI Assistant Tools
 */

export function useListAiAssistantTools<TData = Awaited<ReturnType<typeof listAiAssistantTools>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListAiAssistantToolsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAssistantTools>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiAssistantToolsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






